// Vendors
import { apiUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import { GET_METHOD_FRAME_SERVICE_CONFIGURATION } from './constants/proof-income-landing.services.constants';
// Types
import { ProofIncomeContextType } from 'containers/proof-income/contexts/types/proof-income-landing.contexts.type';
import {
  IdentificationApiResponseErrorType,
  IdentificationApiResponseType,
} from 'types/identification-api-response.type';
// Utils
import { getMethodParam } from './utils/proof-income-landing.services.utils';

const getProofIncomeMethodUrlService = async (
  method: ProofIncomeContextType['selectedMethod']
): Promise<[IdentificationApiResponseType | IdentificationApiResponseErrorType, Response]> =>
  apiUtils.post({
    ...GET_METHOD_FRAME_SERVICE_CONFIGURATION[method],
    params: { ...getMethodParam(method) },
  });

export { getProofIncomeMethodUrlService };
